import Users from './Admin/Users'
import Home from './Home'
import SalesOrderList from './SalesOrder/SalesOrderList'
import SalesOrder from './SalesOrder/SalesOrder'
import NavBar from './Misc/NavBar'
import { Outlet, useLocation } from 'react-router-dom'
import CustomerList from './Customer/CustomerList'
import RmaList from './RMA/RmaList'
import RmaDetails from './RMA/RmaDetails'
import PurchaseOrderList from './Vendor/PurchaseOrderList'
import PurchaseOrderDetails from './Vendor/PurchaseOrderDetails'
import { useEffect } from 'react'
import CogsInvoice from './Reports/CogsInvoice'
import Invoice from './Customer/Invoice/Invoice'
import Payment from './Customer/Payment/Payment'
import Credit from './Customer/CustomerCredit/Credit'

const routes = [
  {
    path: '/',
    element: <NavBarWrapper />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/administration',
        element: <Users />,
      },
      {
        path: '/salesOrder',
        element: <SalesOrderList />,
      },
      {
        path: '/salesOrder/:id',
        element: <SalesOrder />,
      },
      {
        path: '/customer',
        element: <CustomerList />,
      },
      {
        path: '/customer/:tab',
        element: <CustomerList />,
      },
      {
        path: '/rma',
        element: <RmaList />,
      },
      {
        path: '/rma/:id',
        element: <RmaDetails />,
      },
      {
        path: '/vendor/purchaseorder',
        element: <PurchaseOrderList />,
      },
      {
        path: '/vendor/purchaseorder/:id',
        element: <PurchaseOrderDetails />,
      },
      {
        path: '/customer/invoice/:id',
        element: <Invoice />,
      },
      {
        path: '/customer/payment/:id',
        element: <Payment />,
      },
      {
        path: '/customer/credit/:id',
        element: <Credit />,
      },
      {
        path: '/reports/cogsinvoice',
        element: <CogsInvoice />,
      },
    ],
  },
]

function NavBarWrapper() {
  const { pathname } = useLocation()

  const customerList = ['/customer/invoices', '/customer/payments', '/customer/credits']

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <NavBar />
      <Outlet key={customerList.includes(pathname) ? 'customer-list' : pathname} />
    </>
  )
}

export default routes
